import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualEncomenda from '../../actions/encomenda/determinarPaginaAtualEncomenda'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoEncomenda extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualEncomenda}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualEncomenda,
    total: state.encomendas.total,
    registrosPorPagina: state.registrosPorPaginaEncomenda
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualEncomenda }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoEncomenda)
